<section class="iguau-filter-box" aria-label="Filtros y ordenación del muro">
  <div class="filters-bar">
    <button type="button" class="filters-toggle" (click)="desplegableAbierto = !desplegableAbierto"
      [attr.aria-expanded]="desplegableAbierto" aria-controls="iguau-muro-panel-filtros">
      <span class="filters-icon"><i class="fa-solid fa-sliders" aria-hidden="true"></i></span>
      <span class="filters-toggle-copy">
        <strong>Filtrar publicaciones</strong>
        <small>{{ hayFiltrosActivos ? resumenFiltros : 'Todas las publicaciones' }}</small>
      </span>
      <span class="filters-count" *ngIf="numeroFiltrosActivos > 0">{{ numeroFiltrosActivos }}</span>
      <i class="fa-solid fa-chevron-down filters-chevron" [class.is-open]="desplegableAbierto" aria-hidden="true"></i>
    </button>
    <button type="button" class="filters-reset-compact" *ngIf="hayFiltrosActivos" (click)="limpiarFiltros()" title="Restablecer filtros" aria-label="Restablecer filtros">
      <i class="fa-solid fa-arrow-rotate-left" aria-hidden="true"></i>
      <span>Limpiar</span>
    </button>
  </div>

  <div class="filters-active" *ngIf="!desplegableAbierto && hayFiltrosActivos" aria-label="Filtros aplicados">
    <span *ngFor="let tipo of tipopublicaciones" class="active-tag" [hidden]="!tipo.activo">{{ tipo.va_nombre }}</span>
    <span class="active-tag" *ngIf="paseosEstado === 'proximos'">Próximos paseos</span>
    <span class="active-tag" *ngIf="paseosEstado === 'finalizados'">Paseos finalizados</span>
    <span class="active-tag" *ngIf="ordenPublicaciones === 'actividad'">Actividad reciente</span>
  </div>

  <div id="iguau-muro-panel-filtros" class="filters-panel" *ngIf="desplegableAbierto">
    <div class="filters-group">
      <div class="filters-label">¿Qué publicaciones quieres ver?</div>
      <div class="filter-chips" role="group" aria-label="Tipos de publicaciones">
        <button type="button" class="filter-chip" [class.is-active]="seleccionadosCount === 0"
          [attr.aria-pressed]="seleccionadosCount === 0" (click)="quitarTipos()">Todas</button>
        <button *ngFor="let tipo of tipopublicaciones" type="button" class="filter-chip"
          [class.is-active]="tipo.activo" [attr.aria-pressed]="!!tipo.activo"
          (click)="seleccionarTipo(tipo)">{{ tipo.va_nombre }}</button>
      </div>
      <p class="filters-hint">Puedes seleccionar varios tipos a la vez.</p>
    </div>
    <div class="filters-lower">
      <div class="filters-group">
        <div class="filters-label">Estado de los paseos</div>
        <div class="filter-chips" role="group" aria-label="Estado de los paseos">
          <button type="button" class="filter-chip" [class.is-active]="paseosEstado === 'todos'" [attr.aria-pressed]="paseosEstado === 'todos'" (click)="cambiarEstadoPaseos('todos')">Todos</button>
          <button type="button" class="filter-chip" [class.is-active]="paseosEstado === 'proximos'" [attr.aria-pressed]="paseosEstado === 'proximos'" (click)="cambiarEstadoPaseos('proximos')">Próximos</button>
          <button type="button" class="filter-chip" [class.is-active]="paseosEstado === 'finalizados'" [attr.aria-pressed]="paseosEstado === 'finalizados'" (click)="cambiarEstadoPaseos('finalizados')">Finalizados</button>
        </div>
      </div>
      <div class="filters-group">
        <div class="filters-label">Ordenar resultados</div>
        <div class="filter-chips" role="group" aria-label="Orden de las publicaciones">
          <button type="button" class="filter-chip" [class.is-active]="ordenPublicaciones === 'recientes'" [attr.aria-pressed]="ordenPublicaciones === 'recientes'" (click)="cambiarOrden('recientes')">Más recientes</button>
          <button type="button" class="filter-chip" [class.is-active]="ordenPublicaciones === 'actividad'" [attr.aria-pressed]="ordenPublicaciones === 'actividad'" (click)="cambiarOrden('actividad')">Actividad reciente</button>
        </div>
      </div>
    </div>
    <div class="filters-panel-footer">
      <button type="button" class="filters-done" (click)="desplegableAbierto = false"><i class="fa-solid fa-check" aria-hidden="true"></i> Ver publicaciones</button>
    </div>
  </div>
</section>
